import { Client } from '@/types/client';

export const sampleClients: Client[] = [
  {
    id: '1',
    srNo: 1,
    directorName: 'John Smith',
    natureOfBusiness: 'Retail Trade',
    companyName: 'Smith Holdings Pty Ltd',
    clientType: 'Company',
    gstFilling: true,
    abn: '12 345 678 901',
    tfn: '123 456 789',
    emailAddress: 'john@smithholdings.com.au',
    team: 'Team Alpha',
    employee: 'Sarah Johnson',
    statementReceived: true,
    basStatus: 'Completed',
    basReturn: 'Completed',
    payrollPayslip: 'In Progress',
    stpFile: 'Completed',
    superPayment: 'Completed',
    bookkeepingSoftware: 'Xero',
    handyLedger: true,
    bookkeepingStatus: 'Completed',
    invoices: 'Completed',
    remarks: 'Monthly BAS client. Requires quarterly review.',
    createdAt: new Date('2024-01-15'),
    updatedAt: new Date('2024-03-20'),
  },
  {
    id: '2',
    srNo: 2,
    directorName: 'Mary Johnson',
    natureOfBusiness: 'Professional Services',
    companyName: 'Johnson Family Trust',
    clientType: 'Trust',
    gstFilling: true,
    abn: '23 456 789 012',
    tfn: '234 567 890',
    emailAddress: 'mary@johnsontrust.com.au',
    team: 'Team Beta',
    employee: 'Michael Chen',
    statementReceived: false,
    basStatus: 'Pending',
    basReturn: 'Pending',
    payrollPayslip: 'Not Required',
    stpFile: 'Not Required',
    superPayment: 'Not Required',
    bookkeepingSoftware: 'MYOB',
    handyLedger: false,
    bookkeepingStatus: 'In Progress',
    invoices: 'Pending',
    remarks: 'Awaiting bank statements for Q3.',
    createdAt: new Date('2024-02-01'),
    updatedAt: new Date('2024-03-18'),
  },
  {
    id: '3',
    srNo: 3,
    directorName: 'Robert Williams',
    natureOfBusiness: 'Construction',
    companyName: 'Williams Construction',
    clientType: 'Sole Trader',
    gstFilling: true,
    abn: '34 567 890 123',
    tfn: '345 678 901',
    emailAddress: 'rob@williamsconstruction.com.au',
    team: 'Team Alpha',
    employee: 'Sarah Johnson',
    statementReceived: true,
    basStatus: 'Overdue',
    basReturn: 'Overdue',
    payrollPayslip: 'In Progress',
    stpFile: 'Pending',
    superPayment: 'Pending',
    bookkeepingSoftware: 'QuickBooks',
    handyLedger: true,
    bookkeepingStatus: 'Pending',
    invoices: 'In Progress',
    remarks: 'Urgent: BAS overdue by 2 weeks. Follow up required.',
    createdAt: new Date('2023-11-20'),
    updatedAt: new Date('2024-03-22'),
  },
  {
    id: '4',
    srNo: 4,
    directorName: 'Lisa Chen',
    natureOfBusiness: 'Healthcare',
    companyName: 'Chen Medical Practice',
    clientType: 'Partnership',
    gstFilling: false,
    abn: '45 678 901 234',
    tfn: '456 789 012',
    emailAddress: 'lisa@chenmedical.com.au',
    team: 'Team Beta',
    employee: 'Michael Chen',
    statementReceived: true,
    basStatus: 'Not Required',
    basReturn: 'Not Required',
    payrollPayslip: 'Completed',
    stpFile: 'Completed',
    superPayment: 'Completed',
    bookkeepingSoftware: 'Xero',
    handyLedger: false,
    bookkeepingStatus: 'Completed',
    invoices: 'Completed',
    remarks: 'GST exempt. Quarterly payroll processing.',
    createdAt: new Date('2024-01-05'),
    updatedAt: new Date('2024-03-15'),
  },
  {
    id: '5',
    srNo: 5,
    directorName: 'David Brown',
    natureOfBusiness: 'IT Services',
    companyName: 'Brown Tech Solutions Pty Ltd',
    clientType: 'Company',
    gstFilling: true,
    abn: '56 789 012 345',
    tfn: '567 890 123',
    emailAddress: 'david@browntech.com.au',
    team: 'Team Gamma',
    employee: 'Emma Wilson',
    statementReceived: true,
    basStatus: 'In Progress',
    basReturn: 'Pending',
    payrollPayslip: 'Completed',
    stpFile: 'Completed',
    superPayment: 'In Progress',
    bookkeepingSoftware: 'Xero',
    handyLedger: true,
    bookkeepingStatus: 'In Progress',
    invoices: 'In Progress',
    remarks: 'New client. Setting up cloud accounting.',
    createdAt: new Date('2024-03-01'),
    updatedAt: new Date('2024-03-22'),
  },
];
